import { B, staffOf } from "../domain/context.js";
import { avatar } from "../lib/avatar.js";
import { card } from "../components/ui.js";
import { esc, money } from "../lib/fmt.js";

// ---------- SINIFLAR ----------
export function viewSiniflar() {
  const t = B();
  return `<div class="grid gap-4 md:grid-cols-2">
    ${t.classes.map(c => {
      const kids = t.students.filter(s => s.classId === c.id);
      const teacher = staffOf(c.teacherId);
      const helpers = t.staff.filter(p => p.classId === c.id && p.id !== c.teacherId);
      const pct = Math.round(kids.length / c.capacity * 100);
      return card(`
        <div data-class="${c.id}" class="cursor-pointer">
        <div class="h-2 rounded-t-2xl" style="background:${c.color}"></div>
        <div class="p-5">
          <div class="flex items-start justify-between">
            <div>
              <h2 class="font-display font-bold text-lg">
                <a href="#/siniflar/${c.id}" class="hover:underline decoration-2 underline-offset-4" style="text-decoration-color:${c.color}">${esc(c.name)}</a>
              </h2>
              <div class="text-xs text-inksoft">${c.age} · ${esc(c.room)}</div>
            </div>
            <span class="text-xs font-bold rounded-full px-3 py-1" style="background:${c.color}1A;color:${c.color}">${kids.length}/${c.capacity} dolu</span>
          </div>
          <div class="h-2 rounded-full bg-paper overflow-hidden mt-3">
            <div class="h-full rounded-full" style="width:${pct}%;background:${c.color}"></div>
          </div>
          <div class="grid grid-cols-2 gap-2 mt-4">
            <div class="rounded-xl bg-paper p-3">
              <div class="text-[10px] font-bold text-inksoft uppercase">Tam Gün</div>
              <div class="font-display font-bold text-lg">${money(c.tuition)}</div>
            </div>
            <div class="rounded-xl bg-paper p-3">
              <div class="text-[10px] font-bold text-inksoft uppercase">Yarım Gün</div>
              <div class="font-display font-bold text-lg">${money(c.tuitionHalf)}</div>
            </div>
          </div>
          <div class="mt-4 text-sm">
            <div class="font-semibold">👩‍🏫 ${esc(teacher?.name ?? "—")}</div>
            ${helpers.map(h => `<div class="text-inksoft text-xs mt-0.5">🤝 ${esc(h.name)} · ${esc(h.role)}</div>`).join("")}
            <div class="text-inksoft text-xs mt-0.5">📐 Oran hedefi: ${esc(c.ratio)}</div>
          </div>
          <div class="flex flex-wrap gap-1.5 mt-4">
            ${kids.map(s => `<button data-student="${s.id}" title="${esc(s.name)}">${avatar(s, "w-8 h-8 text-[10px]")}</button>`).join("")}
          </div>
          <div class="mt-4 pt-3 border-t border-line/70 text-xs font-semibold" style="color:${c.color}">Sınıf detayı →</div>
        </div>
        </div>`, "overflow-hidden hover:shadow-pop transition-shadow");
    }).join("")}
  </div>`;
}

